module.exports = __webpack_public_path__ + "img/nsf.46583e7.png";